<template>
  <el-pagination
    :small="small"
    background
    :layout="layout"
    :page-size="pagingData.pageSize"
    :page-sizes="pagingData.pageList"
    :total="pagingData.total"
    :current-page="pagingData.currentPage"
    @size-change="sizeChange"
    @current-change="currentChange">
  </el-pagination>
</template>

<script>
export default {
  name: "vuePagination",
  props: {
    pagingData: Object,
    small: Boolean,
    layout: {
      type: String,
      default: "prev, pager, next, sizes, jumper",
    }
  },
  methods: {
    sizeChange(size) {
      this.pagingData.currentPage = 1;
      this.pagingData.pageSize = size;
      this.$emit("table-reload");
    },
    currentChange: function (currentPage) {
      this.pagingData.currentPage = currentPage;
      this.$emit("table-reload");
    },
    removeFinish(count) {
      this.pagingData.currentPage = this.checkCurrentPage(
        this.pagingData.total,
        count,
        this.pagingData.pageSize,
        this.pagingData.currentPage
      );
    }
  }
}
</script>

<style scoped>

</style>
